import React from 'react';
import { Search } from './components/Search';
import { CreateBtn } from './components/CreateBtn';
import { ResetBtn } from './components/ResetBtn';
import { SortBy } from './components/SortBy/SortBy';
import { CountOfItem } from './components/CountOfItem';
import { WithURLFilters } from './components/WithURLFilters';
import style from './CredentialsControlPanel.module.scss';

export const CredentialsControlPanel: React.FC = () => {
	return (
		<WithURLFilters>
			<div className={style.firstRowWithControls}>
				<Search />
				<CreateBtn />
			</div>
			<div className={style.secondRowWithControls}>
				<ResetBtn />
				<SortBy />
				<CountOfItem />
			</div>
		</WithURLFilters>
	);
};
